import { takeLatest, put, select } from 'redux-saga/effects';
import { Map as ImmutableMap } from 'immutable';

import * as transactionActions from 'data/transactions/actions';
import { getTransactionsByAccountId } from 'data/transactions/selectors';
import { getAccountsById } from 'data/accounts/selectors';
import { isUncategorizedTxn } from 'data/transactions/utils';
import { getFieldString } from 'data/transactions/searchFilter';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

import * as actions from './actions';


export function buildPayeeList(accountsById, transactionsByAccountId, resources) {

  let changedAccounts;
  if (resources) {
    changedAccounts = resources.map((x) => x.accountId);
    changedAccounts = changedAccounts.filter((item, pos) => changedAccounts.indexOf(item) === pos);
  } else {
    changedAccounts = accountsById.map((x) => x.id);
  }

  let payeeListById = new ImmutableMap();

  // now for each account changed, rebuild the payee list
  changedAccounts.forEach((accountId) => {

    const acct = accountsById.get(accountId);
    if (acct && acct.type !== 'LOAN') {
      let payeeList = new ImmutableMap();
      const txns = transactionsByAccountId.get(accountId);
      txns && txns.forEach((txn) => {
        if (!txn.isDeleted && !isUncategorizedTxn(txn)) {   // don't process recently deleted transactions or uncategorized transactions
          if (txn.payee && txn.payee.length > 2) {

            const payeeObject = {
              id: uuidv4(),
              name: txn.payee,
              amountString: getFieldString('amount', txn),
              catString: getFieldString('category', txn),
              tagString: getFieldString('tags', txn),
              txn,
            };

            const key = txn.payee ? txn.payee.toLowerCase() : '';
            const prevTxn = payeeList.get(key);
            if (prevTxn) {
              if (moment(prevTxn.txn.postedOn).isBefore(moment(txn.postedOn))) {
                payeeList = payeeList.set(key, payeeObject);
              }
            } else {
              payeeList = payeeList.set(key, payeeObject);
            }
          }
        }
      });
      if (payeeList.size > 0) {
        payeeListById = payeeListById.set(accountId, payeeList);
      }
    }
  });

  return payeeListById;

}

export function* updatePayeeList(data) {

  if (data && data.payload && data.payload.resources) {

    const transactionsByAccountId = yield select(getTransactionsByAccountId);
    const accountsById = yield select(getAccountsById);
    const payeeListById = buildPayeeList(accountsById, transactionsByAccountId, data.payload.resources);

    yield put(actions.updatePayeeListSuccess(payeeListById));

  }
}

export function* triggerPayeeListUpdate(data) {

  yield put(actions.updatePayeeListAsync(data.payload));

}

export function* updatePayeeListActionWatcher() {
  yield takeLatest(actions.updatePayeeList, updatePayeeList);
}

export function* transactionChangeActionWatcher() {
  yield takeLatest([
    transactionActions.updateTransactionsSuccessOptimistic,
    transactionActions.createTransactionsSuccessOptimistic,
    // transactionActions.deleteTransactionsSuccess,  // we don't update on delete, too chatty with optimistic updating
    transactionActions.getTransactionsSuccess,
  ], triggerPayeeListUpdate);

}

// ====================================================
// EXPORTS

export default [
  updatePayeeListActionWatcher,
  transactionChangeActionWatcher,
];
